import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useFetch } from '@stashinvest/use-fetch';
import { useInterval } from 'stash/utils/hooks';
import LinkPlaidLoading from './LinkPlaidLoading';
import { trackOnSetupFailed, trackOnSetupSucceeded } from './LinkPlaidEvents';

const POLL_TIMEOUT = 60000;
const POLL_INTERVAL = 1000;

const STATUS = {
	CONNECTING: 'connecting',
	CONNECTED: 'connected',
	DISCONNECTED: 'disconnected',
	FAILED: 'failed',
};

const LinkPlaidLinking = ({
	linkId,
	onSuccess,
	onError,
	onReason,
	onTimeout,
	setIsLinked,
	trackEvent,
	isOnboarding,
}) => {
	const pollStartTime = useRef(new Date().getTime());

	const { fetch } = useFetch({
		path: `/apis/externalAccounts/api/v1/users/:uuid/link/plaid/${linkId}`,
		onError: () => {
			trackOnSetupFailed(isOnboarding, trackEvent);
			onError();
		},
	});

	useInterval(() => {
		if (new Date().getTime() - pollStartTime.current >= POLL_TIMEOUT) {
			return onTimeout();
		}

		fetch().then((res) => {
			const status = res.link.status;
			if (status === STATUS.CONNECTED) {
				trackOnSetupSucceeded(isOnboarding, trackEvent);

				setIsLinked(true);
				onSuccess();
			}
			if (status === STATUS.DISCONNECTED || status === STATUS.FAILED) {
				trackOnSetupFailed(isOnboarding, trackEvent);

				return !res.link.reason ? onError() : onReason(res.link.reason);
			}
		});
	}, POLL_INTERVAL);

	return <LinkPlaidLoading trackEvent={trackEvent} isOnboarding={isOnboarding} />;
};

LinkPlaidLinking.propTypes = {
	linkId: PropTypes.string,
	onSuccess: PropTypes.func,
	onError: PropTypes.func,
	onReason: PropTypes.func,
	trackEvent: PropTypes.func,
	isOnboarding: PropTypes.bool,
};

export default LinkPlaidLinking;
